import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import {ParserRegistry} from "ngl";
import SpeedDial from "@material-ui/lab/SpeedDial";
import SpeedDialIcon from "@material-ui/lab/SpeedDialIcon";
import SpeedDialAction from "@material-ui/lab/SpeedDialAction";
import NGLContext from "../NGLContext";
import UploadIcon from '@material-ui/icons/CloudUpload'
import DownloadIcon from '@material-ui/icons/CloudDownload'
import {viewHeight} from "./ViewPanel";


const styles = theme => ({
    speedDial: {
        position: 'absolute',
        bottom: '0.5rem',
        right: '0.5rem',
        height: viewHeight,
    },
    input: {
        display: 'none',
    },
});


@withStyles(styles)
class NGLSpeedDials extends Component {

    static propTypes = {
        classes: PropTypes.object.isRequired,
        stage: PropTypes.object
    };

    state = {
        open: false,
        hidden: false,
        fileList: {}
    };

    constructor(props) {
        super(props);
        this.fileInput = React.createRef();
        this.handleClick = this.handleClick.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleOpen = this.handleOpen.bind(this);
        this.handleUpload = this.handleUpload.bind(this);
        this.showFileUpload = this.showFileUpload.bind(this);
    }

    handleClick = () => {
        this.setState(state => ({
            open: !state.open,
        }));
    };

    handleClose = () => {
        this.setState({open: false});
    };

    handleOpen = () => {
        this.setState({open: true});
    };

    handleUpload = (event, callback) => {
        // TODO: Is it the better way to add a nglfile to the state list ?
        event.preventDefault();
        // console.log(this.fileInput);
        if (this.fileInput.current.files.length) {
            console.log("Submit NGL file");
            // Using the spread operator to loop in the filelist since it
            // is not really an array object
            var tmpList = {...this.state.fileList};
            [...this.fileInput.current.files].map(async (NGLFile) => {
                // console.log(NGLFile);
                if (!(NGLFile.name in tmpList)) {
                    // console.log("ADD THE FILE");
                    tmpList[NGLFile.name] = NGLFile;
                    // TODO: Load the file with NGL in the viewport panel
                    await this.props.stage.loadFile(NGLFile,
                        {defaultRepresentation: true}).then(
                        (structureComponent) => {
                            this.setState({fileList: tmpList});
                            callback();
                        }
                    );
                } else {
                    // console.log("DUPLICATE FILE");
                    // TODO: show some kind of warning to the user
                }
            });
            // this.setState({fileList: tmpList}, () => {console.log("SETSTATE CALLBACK")});
        } else {
            console.log("No files");
        }
    };

    showFileUpload() {
        this.fileInput.current.click();
    }


    render() {
        const {classes} = this.props;
        const {open, hidden} = this.state;

        return (
            <NGLContext.Consumer>
                {(contextNGL) => (
                    <React.Fragment>
                        <input
                            accept={"." + ParserRegistry.names.join(",.")}
                            className={classes.input}
                            id="upload-button-file"
                            multiple
                            type="file"
                            onChange={(event) => {
                                this.handleUpload(event, contextNGL.handleRefresh)
                            }}
                            ref={this.fileInput}
                        />
                        <SpeedDial
                            ariaLabel="NGL SpeedDial"
                            className={classes.speedDial}
                            hidden={hidden}
                            icon={<SpeedDialIcon/>}
                            onBlur={this.handleClose}
                            onClick={this.handleClick}
                            onClose={this.handleClose}
                            onFocus={this.handleOpen}
                            onMouseEnter={this.handleOpen}
                            onMouseLeave={this.handleClose}
                            open={open}
                            direction='up'
                        >
                            <SpeedDialAction
                                key="Download"
                                icon={<DownloadIcon/>}
                                tooltipTitle="Download"
                                href={contextNGL.pdb}
                            />
                            <SpeedDialAction
                                key="Upload"

                                icon={<UploadIcon/>}
                                tooltipTitle="Upload"
                                onClick={this.showFileUpload}/>
                        </SpeedDial>
                    </React.Fragment>
                )}
            </NGLContext.Consumer>
        );
    }
}

export default NGLSpeedDials;